
<div>
  <b-container fluid style="margin-top: 70px">
    <b-row>
      <b-col>
        <b-breadcrumb>
          <b-breadcrumb-item
              text="Profile"
              active>
          </b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
    </b-row>
  </b-container>
  <yega1-modal-form ref="input_form"
                    store-name="DeviseAuthStore"
                    v-on:cancelled="handleCancelled"
                    no-destroy>
    <template v-slot:header>
      <h2>User Profile</h2>
    </template>
    <template v-slot:fields="data">
      <yega1-form-group-input label="Username"
                              :item="data.item"
                              field="username"
                              required>
      </yega1-form-group-input>
      <yega1-form-group-input label="First Name"
                              :item="data.item"
                              field="first_name">
      </yega1-form-group-input>
      <yega1-form-group-input label="Last Name"
                              :item="data.item"
                              field="last_name">
      </yega1-form-group-input>
      <yega1-form-group-input label="E-Mail"
                              :item="data.item"
                              field="email"
                              type="email"
                              required>
      </yega1-form-group-input>
      <yega1-form-group-input label="Password"
                              :item="data.item"
                              field="password"
                              type="password">
      </yega1-form-group-input>
    </template>
  </yega1-modal-form>
</div>
